import { Header as FHeader, Navigation } from 'festo-react-ui-kit';
import React, { useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { useNormalizeAssetPath } from '../../features/base/hooks/useBase';

const Header: React.FC = () => {
  const linkRef = useRef<HTMLAnchorElement>(null);

  const normalizeAssetPath = useNormalizeAssetPath();

  function handleLogoClick(e: React.MouseEvent) {
    e.preventDefault();
    linkRef.current?.click();
  }

  return (
    <FHeader>
      <NavLink ref={linkRef} to="" className="navlink" />
      <Navigation logoHref={``} onLogoClick={handleLogoClick} logoSrc={normalizeAssetPath('img/logo_blue.svg')} />
    </FHeader>
  );
};

export default Header;
